export default __webpack_public_path__ + "static/media/messageIconActive.2fdba648.svg";